import { ColumnProps } from 'antd/lib/table';
import { format } from 'date-fns';
import { useCustomTranslation } from '../../../hooks/custom-translation';

import {
  currencyMask,
  maskCep,
  maskCpf,
  maskPhone,
} from '../../../helpers/masks/masksRegex';
import { ContactProps } from '../../../services/contact';
import { Content02, TableGroup } from './styles';

interface IProps {
  contactInfo: ContactProps | undefined;
}

const Enrichment = ({ contactInfo }: IProps) => {
  const { tContactSegmentsEdit } = useCustomTranslation('contactSegmentsEdit');

  interface TableGroupProps {
    key: string;
    atributo: string;
    valor: any;
  }
  const dataTableGroup: TableGroupProps[] = [
    {
      key: '0',
      atributo: tContactSegmentsEdit('name'),
      valor: contactInfo?.enriched?.name || '-',
    },
    {
      key: '1',
      atributo: tContactSegmentsEdit('cpf'),
      valor: maskCpf(contactInfo?.enriched?.document as string) || '-',
    },
    {
      key: '2',
      atributo: 'RG',
      valor: contactInfo?.enriched?.rg || '-',
    },
    {
      key: '3',
      atributo: tContactSegmentsEdit('birthdate'),
      valor: contactInfo?.enriched?.birthDate
        ? format(
            new Date(contactInfo?.enriched?.birthDate as any),
            'dd/MM/yyyy',
          )
        : '-',
    },
    {
      key: '4',
      atributo: tContactSegmentsEdit('backyard_-_type'),
      valor: contactInfo?.enriched?.addressType || '-',
    },
    {
      key: '5',
      atributo: tContactSegmentsEdit('backyard_-_title'),
      valor: contactInfo?.enriched?.addressTitle || '-',
    },

    {
      key: '6',
      atributo: tContactSegmentsEdit('backyard_-_name'),
      valor: contactInfo?.enriched?.address || '-',
    },

    {
      key: '7',
      atributo: tContactSegmentsEdit('backyard_-_number'),
      valor: contactInfo?.enriched?.addressNumber || '-',
    },

    {
      key: '8',
      atributo: tContactSegmentsEdit('patio_-_complement'),
      valor: contactInfo?.enriched.additionalAddressDetail || '-',
    },

    {
      key: '9',
      atributo: tContactSegmentsEdit('neighborhood'),
      valor: contactInfo?.enriched?.district || '-',
    },

    {
      key: '10',
      atributo: tContactSegmentsEdit('town'),
      valor: contactInfo?.enriched?.city || '-',
    },

    {
      key: '11',
      atributo: tContactSegmentsEdit('statehood'),
      valor: contactInfo?.enriched?.federativeUnit || '-',
    },

    {
      key: '12',
      atributo: tContactSegmentsEdit('zip_code'),
      valor: maskCep(contactInfo?.enriched?.postalCode as string),
    },
    {
      key: '59',
      atributo: tContactSegmentsEdit('backyard_-_type_2'),
      valor: contactInfo?.enriched?.addressType2 || '-',
    },
    {
      key: '63',
      atributo: tContactSegmentsEdit('backyard_-_title_2'),
      valor: contactInfo?.enriched?.addressTitle2 || '-',
    },
    {
      key: '67',
      atributo: tContactSegmentsEdit('backyard_-_name_2'),
      valor: contactInfo?.enriched?.address2 || '-',
    },
    {
      key: '71',
      atributo: tContactSegmentsEdit('backyard_-_number_2'),
      valor: contactInfo?.enriched?.addressNumber2 || '-',
    },
    {
      key: '75',
      atributo: tContactSegmentsEdit('patio_-_complement_2'),
      valor: contactInfo?.enriched.additionalAddressDetail2 || '-',
    },
    {
      key: '79',
      atributo: tContactSegmentsEdit('neighborhood_2'),
      valor: contactInfo?.enriched.district2 || '-',
    },
    {
      key: '83',
      atributo: tContactSegmentsEdit('town_2'),
      valor: contactInfo?.enriched.city2 || '-',
    },
    {
      key: '87',
      atributo: tContactSegmentsEdit('statehood_2'),
      valor: contactInfo?.enriched.federativeUnit2 || '-',
    },
    {
      key: '91',
      atributo: tContactSegmentsEdit('zip_code_2'),
      valor: maskCep(contactInfo?.enriched.postalCode2 as string),
    },
    {
      key: '60',
      atributo: tContactSegmentsEdit('backyard_-_type_3'),
      valor: contactInfo?.enriched?.addressType3 || '-',
    },
    {
      key: '61',
      atributo: tContactSegmentsEdit('backyard_-_title_3'),
      valor: contactInfo?.enriched?.addressTitle3 || '-',
    },
    {
      key: '62',
      atributo: tContactSegmentsEdit('backyard_-_name_3'),
      valor: contactInfo?.enriched?.address3 || '-',
    },
    {
      key: '63',
      atributo: tContactSegmentsEdit('backyard_-_number_3'),
      valor: contactInfo?.enriched?.addressNumber3 || '-',
    },
    {
      key: '64',
      atributo: tContactSegmentsEdit('patio_-_complement_3'),
      valor: contactInfo?.enriched.additionalAddressDetail3 || '-',
    },
    {
      key: '65',
      atributo: tContactSegmentsEdit('neighborhood_3'),
      valor: contactInfo?.enriched.district3 || '-',
    },
    {
      key: '66',
      atributo: tContactSegmentsEdit('town_3'),
      valor: contactInfo?.enriched.city3 || '-',
    },
    {
      key: '67',
      atributo: tContactSegmentsEdit('statehood_3'),
      valor: contactInfo?.enriched.federativeUnit3 || '-',
    },
    {
      key: '68',
      atributo: tContactSegmentsEdit('zip_code_3'),
      valor: maskCep(contactInfo?.enriched.postalCode3 as string),
    },
    {
      key: '69',
      atributo: tContactSegmentsEdit('backyard_-_type_4'),
      valor: contactInfo?.enriched?.addressType4 || '-',
    },
    {
      key: '70',
      atributo: tContactSegmentsEdit('backyard_-_title_4'),
      valor: contactInfo?.enriched?.addressTitle4 || '-',
    },
    {
      key: '71',
      atributo: tContactSegmentsEdit('backyard_-_name_4'),
      valor: contactInfo?.enriched?.address4 || '-',
    },
    {
      key: '72',
      atributo: tContactSegmentsEdit('backyard_-_number_4'),
      valor: contactInfo?.enriched?.addressNumber4 || '-',
    },
    {
      key: '73',
      atributo: tContactSegmentsEdit('patio_-_complement_4'),
      valor: contactInfo?.enriched.additionalAddressDetail4 || '-',
    },
    {
      key: '74',
      atributo: tContactSegmentsEdit('neighborhood_4'),
      valor: contactInfo?.enriched.district4 || '-',
    },
    {
      key: '75',
      atributo: tContactSegmentsEdit('town_4'),
      valor: contactInfo?.enriched.city4 || '-',
    },
    {
      key: '76',
      atributo: tContactSegmentsEdit('statehood_4'),
      valor: contactInfo?.enriched.federativeUnit4 || '-',
    },
    {
      key: '77',
      atributo: tContactSegmentsEdit('zip_code_4'),
      valor: maskCep(contactInfo?.enriched.postalCode4 as string),
    },
    {
      key: '78',
      atributo: tContactSegmentsEdit('backyard_-_type_5'),
      valor: contactInfo?.enriched?.addressType5 || '-',
    },
    {
      key: '79',
      atributo: tContactSegmentsEdit('backyard_-_title_5'),
      valor: contactInfo?.enriched?.addressTitle5 || '-',
    },
    {
      key: '80',
      atributo: tContactSegmentsEdit('backyard_-_name_5'),
      valor: contactInfo?.enriched?.address5 || '-',
    },
    {
      key: '81',
      atributo: tContactSegmentsEdit('backyard_-_number_5'),
      valor: contactInfo?.enriched?.addressNumber5 || '-',
    },
    {
      key: '82',
      atributo: tContactSegmentsEdit('patio_-_complement_5'),
      valor: contactInfo?.enriched.additionalAddressDetail5 || '-',
    },
    {
      key: '83',
      atributo: tContactSegmentsEdit('neighborhood_5'),
      valor: contactInfo?.enriched.district5 || '-',
    },
    {
      key: '84',
      atributo: tContactSegmentsEdit('town_5'),
      valor: contactInfo?.enriched.city5 || '-',
    },
    {
      key: '85',
      atributo: tContactSegmentsEdit('statehood_5'),
      valor: contactInfo?.enriched.federativeUnit5 || '-',
    },
    {
      key: '86',
      atributo: tContactSegmentsEdit('zip_code_5'),
      valor: maskCep(contactInfo?.enriched.postalCode5 as string),
    },
    {
      key: '13',
      atributo: tContactSegmentsEdit('landline'),
      valor:
        typeof contactInfo?.enriched?.phoneNumbers === 'string'
          ? (contactInfo?.enriched?.phoneNumbers as string)
              .split(' ')
              .map(
                (phone: string, index: number) =>
                  `${index > 0 ? ',' : ''} ${maskPhone(phone)}`,
              )
          : contactInfo?.enriched?.phoneNumbers?.map(
              (phone: string, index: number) =>
                `${index > 0 ? ',' : ''} ${maskPhone(phone)}`,
            ) || '-',
    },
    {
      key: '14',
      atributo: tContactSegmentsEdit('cell_phone'),
      valor:
        typeof contactInfo?.enriched?.cellPhones === 'string'
          ? (contactInfo?.enriched?.cellPhones as string)
              .split(' ')
              .map((cellphone: string) => `${maskPhone(cellphone)}`)
          : contactInfo?.enriched?.cellPhones?.map(
              (cellphone: string, index: number) =>
                `${index > 0 ? ',' : ''} ${maskPhone(cellphone)}`,
            ) || '-',
    },
    {
      key: '15',
      atributo: tContactSegmentsEdit('e-mail'),
      valor: contactInfo?.enriched?.emails.map(email => `${email} `) || '-',
    },
    {
      key: '16',
      atributo: tContactSegmentsEdit('sex'),
      valor: contactInfo?.enriched?.gender === 'M' ? 'Masculino' : 'Feminino',
    },
    {
      key: '17',
      atributo: tContactSegmentsEdit('geolocation_(latitudelongitude)'),
      valor:
        contactInfo?.enriched.latitude || contactInfo?.enriched.longitude
          ? `${contactInfo?.enriched.latitude}, ${contactInfo?.enriched.longitude}`
          : '-',
    },
    {
      key: '18',
      atributo: tContactSegmentsEdit('presumed_individual_income'),
      valor: currencyMask(
        contactInfo?.enriched?.presumedIndividualIncome as number,
      ),
    },
    {
      key: '19',
      atributo: tContactSegmentsEdit('family_income'),
      valor: currencyMask(contactInfo?.enriched?.householdIncome as number),
    },
    {
      key: '20',
      atributo: tContactSegmentsEdit('marital_status'),
      valor: contactInfo?.enriched?.maritalStatus || '-',
    },
    {
      key: '21',
      atributo: tContactSegmentsEdit('internal_revenue_service_status'),
      valor: contactInfo?.enriched?.federalRevenueStatus || '-',
    },
    {
      key: '22',
      atributo: tContactSegmentsEdit('occupation'),
      valor: contactInfo?.enriched?.profession || '-',
    },
    {
      key: '23',
      atributo: tContactSegmentsEdit('schooling'),
      valor: contactInfo?.enriched?.educationLevel || '-',
    },
    {
      key: '24',
      atributo: tContactSegmentsEdit('bolsa_familia?'),
      valor: tContactSegmentsEdit(
        contactInfo?.enriched?.hasFamilyAllowance ? 'yes' : 'nope',
      ),
    },
    {
      key: '25',
      atributo: 'Participação em Empresas',
      valor: contactInfo?.enriched.hasCompanyParticipation || '-',
    },
    {
      key: '26',
      atributo: tContactSegmentsEdit('emergency_assistance?'),
      valor: tContactSegmentsEdit(
        contactInfo?.enriched?.hasEmergencyAid ? 'yes' : 'nope',
      ),
    },
    {
      key: '27',
      atributo: tContactSegmentsEdit('retired?'),
      valor: tContactSegmentsEdit(
        contactInfo?.enriched?.isRetired ? 'yes' : 'nope',
      ),
    },
    {
      key: '28',
      atributo: tContactSegmentsEdit('death?'),
      valor: tContactSegmentsEdit(
        contactInfo?.enriched?.isDeath ? 'yes' : 'nope',
      ),
    },
    {
      key: '29',
      atributo: tContactSegmentsEdit('related_pep'),
      valor: contactInfo?.enriched.relatedPepCount || '-',
    },
    {
      key: '30',
      atributo: tContactSegmentsEdit('pep'),
      valor: tContactSegmentsEdit(contactInfo?.enriched.isPep ? 'yes' : 'nope'),
    },
    {
      key: '31',
      atributo: tContactSegmentsEdit('psychographic_credit_score'),
      valor: contactInfo?.enriched.financialScore || '-',
    },
    {
      key: '32',
      atributo: tContactSegmentsEdit('segment_name'),
      valor: contactInfo?.enriched.segmentName || '-',
    },
    {
      key: '33',
      atributo: tContactSegmentsEdit('propensity_for_neuroticism'),
      valor: `${contactInfo?.enriched.scoreNeur}%` || '-',
    },
    {
      key: '34',
      atributo: tContactSegmentsEdit('propensity_to_be_open_to'),
      valor: `${contactInfo?.enriched.scoreAber}%` || '-',
    },
    {
      key: '35',
      atributo: tContactSegmentsEdit('propensity_for_extroversion'),
      valor: `${contactInfo?.enriched.scoreExtr}%` || '-',
    },
    {
      key: '36',
      atributo: tContactSegmentsEdit('propensity_to_conscientiousness'),
      valor: `${contactInfo?.enriched.scoreCons}%` || '-',
    },
    {
      key: '37',
      atributo: tContactSegmentsEdit('brand_trust'),
      valor: `${contactInfo?.enriched.brandTrust}%` || '-',
    },
    {
      key: '38',
      atributo: tContactSegmentsEdit('potential_digital_consumption'),
      valor: `${contactInfo?.enriched.digitalConsumptionPotential}%` || '-',
    },
    {
      key: '39',
      atributo: tContactSegmentsEdit('expediency'),
      valor: `${contactInfo?.enriched.convenience}%` || '-',
    },
    {
      key: '40',
      atributo: tContactSegmentsEdit('cost-benefit_ratio'),
      valor: `${contactInfo?.enriched.costBenefit}%` || '-',
    },
    {
      key: '41',
      atributo: tContactSegmentsEdit(
        'esg_(environmental,_social_and_governmental)',
      ),
      valor: `${contactInfo?.enriched.esg}%` || '-',
    },
    {
      key: '42',
      atributo: tContactSegmentsEdit('shopping_experience'),
      valor: `${contactInfo?.enriched.shoppingExperience}%` || '-',
    },
    {
      key: '43',
      atributo: tContactSegmentsEdit('ease_of_payment'),
      valor: `${contactInfo?.enriched.easeOfPayment}%` || '-',
    },
    {
      key: '44',
      atributo: tContactSegmentsEdit('influence_offline'),
      valor: `${contactInfo?.enriched.influenceOfflineConsumption}%` || '-',
    },
    {
      key: '45',
      atributo: tContactSegmentsEdit('influence_online_consumption'),
      valor: `${contactInfo?.enriched.influenceOnlineConsumption}%` || '-',
    },
    {
      key: '46',
      atributo: tContactSegmentsEdit('innovation'),
      valor: `${contactInfo?.enriched.innovation}%` || '-',
    },
    {
      key: '47',
      atributo: tContactSegmentsEdit('social_status'),
      valor: `${contactInfo?.enriched.socialStatus}%` || '-',
    },
    {
      key: '48',
      atributo: tContactSegmentsEdit('seasonal_value'),
      valor: `${contactInfo?.enriched.seasonalValue}%` || '-',
    },
    {
      key: '49',
      atributo: tContactSegmentsEdit('economic_advantage'),
      valor: `${contactInfo?.enriched.economicAdvantage}%` || '-',
    },
    {
      key: '50',
      atributo: tContactSegmentsEdit('physical_retail'),
      valor: `${contactInfo?.enriched.physicalRetail}%` || '-',
    },
    {
      key: '51',
      atributo: tContactSegmentsEdit('financial_risk'),
      valor: contactInfo?.enriched.psychoFinancialRisk || '-',
    },
    {
      key: '52',
      atributo: 'Brinde',
      valor: `${contactInfo?.enriched.gift}%` || '-',
    },
    {
      key: '53',
      atributo: 'Estabilidade',
      valor: `${contactInfo?.enriched.stability}%` || '-',
    },
    {
      key: '54',
      atributo: 'Instabilidade',
      valor: `${contactInfo?.enriched.instability}%` || '-',
    },
    {
      key: '55',
      atributo: 'Opção de Pagamento',
      valor: `${contactInfo?.enriched.pagOption}%` || '-',
    },
    {
      key: '56',
      atributo: 'Premium',
      valor: `${contactInfo?.enriched.premium}%` || '-',
    },
    {
      key: '57',
      atributo: 'Premium Serviço',
      valor: `${contactInfo?.enriched.premiumService}%` || '-',
    },
    {
      key: '58',
      atributo: 'Nome do Arquivo',
      valor: contactInfo?.enriched.id || '-',
    },
  ];
  const columnsTableGroup: ColumnProps<any>[] = [
    {
      title: tContactSegmentsEdit('attribute'),
      dataIndex: 'atributo',
      width: '50%',
      align: 'left',
      sorter: (a, b) => a.atributo.length - b.atributo.length,
    },
    {
      title: tContactSegmentsEdit('valor'),
      dataIndex: 'valor',
      align: 'left',
      width: '50%',
      sorter: (a, b) => a.valor.length - b.valor.length,
    },
  ];

  return (
    <>
      <Content02>
        <TableGroup dataSource={dataTableGroup} columns={columnsTableGroup} />
      </Content02>
    </>
  );
};

export default Enrichment;
